// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"232":"8f25cdb7","419":"a3137285","569":"07e610ef","575":"f7184919","638":"0eb7dcce","852":"4da3a03b","931":"846591eb"}[chunkId] + ".chunk.js";
};